import React, { useContext } from 'react';
import Loading from 'components/Loading';
import { useParams } from 'react-router-dom';
import BudgetHeader from 'routes/BudgetModule/components/shared/BudgetHeader/BudgetHeader';
import '../_budgetProposal.scss';
import ResourceContent from './components/ResourceContent';
import CurrentBudgetProposalProvider from './contexts/CurrentBudgetProposalProvider';
import { useTranslation } from 'react-i18next';
import { useGetResourceName } from './hooks/resource';
import { CurrentBudgetProposalContext } from 'routes/BudgetModule/components/BudgetProposal/Resource/contexts/CurrentBudgetProposalContext';

const Resource = (): React.ReactElement => {
    const { budgetProposalId = '', resourceSoftwareId = '' } = useParams();
    const { t } = useTranslation();

    const currentBudgetP = useContext(CurrentBudgetProposalContext);

    const { data: resourceName = '', isLoading: isResourceNameLoading } =
        useGetResourceName({
            softwareId: resourceSoftwareId,
            budgetProposalId: currentBudgetP.id,
            by: currentBudgetP.by,
            enabled: !!resourceSoftwareId,
        });

    if (isResourceNameLoading)
        return (
            <div className="budget-loader">
                <Loading pastDelay />
            </div>
        );
    return (
        <div className="page-container budget-proposal-wrapper">
            <BudgetHeader
                headerTitle={t('budgetProposal.headerTitle')}
                parentLink={`/budget_proposal/${budgetProposalId}`}
                budgetProposal={currentBudgetP}
                resourceName={resourceName}
                resourceSoftwareId={resourceSoftwareId}
                shouldUseLighterShadow
                exercice={currentBudgetP.exercice}
            />
            <ResourceContent resourceName={resourceName} />
        </div>
    );
};

const ResourceWithProvider = () => {
    const { budgetProposalId = '' } = useParams();
    return (
        <CurrentBudgetProposalProvider
            budgetProposalId={parseInt(budgetProposalId, 10)}
        >
            <Resource />
        </CurrentBudgetProposalProvider>
    );
};

export default ResourceWithProvider;
